import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText.js';
import SupportRequestPresenter, {
  CLOSE,
} from '../../presenters/SupportRequestPresenter';

export const validationFields = {
  reviewerComment: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (request) => {
  const initialValues = {
    state: CLOSE,
    reviewerComment: SupportRequestPresenter.reviewerComment(request) || '',
  };

  return initialValues;
};
